/* eslint-disable react/destructuring-assignment */
import React, { Component } from "react";
import { connect } from "react-redux";
// import styled from "styled-components";
import Collapse from "@alboompro/boom-components/data-display/collapse";
import Icon from "@alboompro/boom-components/general/icon";
import {
  CollapseWrapper,
  IconWrapper,
  BorderedWrapper,
  BorderedItem,
  Tooltip,
  IconQuestionWrapper
} from "editor/components/CollapseWrapper";
import EditorLabel from "editor/components/EditorLabel";
import Switch from "./SwitchComponent/Switch";

const { Panel } = Collapse;

class Group extends Component {
  constructor(props) {
    super(props);
    const { name, enabled, toggleable, updaterFn, currentProps } = props;

    // If toggeable is enabled, but the corresponding prop doesn't
    // exist in the element being rendered, set it.
    if (toggleable && !(`${name}Enabled` in currentProps)) {
      updaterFn({ props: `${name}Enabled`, value: enabled });
    }

    this.state = {
      enabled: props.enabled || false,
    };
  }

  /**
   * fix update children problems
   */
  // shouldComponentUpdate(){
  //   return false
  // }

  /**
   * Handles the action of enabling or disabling the group collapse
   * when toggleable option is active. Else, it just return so the
   * data flow can continue until it reaches the original collapse
   * element.
   *
   */
  handleToggableGroup = () => {
    const { updaterFn, name, toggleable, groupType } = this.props;
    if (!toggleable || groupType === "separator") {
      return;
    }
    const { enabled } = this.state;
    this.setState({ enabled: !enabled }, () => {
      updaterFn({ prop: `${name}Enabled`, value: !enabled });
    });
  };

  /**
   *
   * If it's toggleable, render a switch as the expandIcon, else
   * render the normal arrow.
   *
   * @param {Boolean} isActive indicator for toggle active
   */

  expandIcon = (isActive) => {
    const { toggleable, groupType } = this.props;
    const { enabled } = this.state;

    if (groupType === "separator") {
      return null;
    }

    if (toggleable || groupType === "switch") {
      return <Switch value={enabled} onClick={this.handleToggableGroup} />;
    } 
      return (
        <IconWrapper open={isActive}>
          <Icon
            kind="bold"
            group="arrows-diagrams"
            category="arrows"
            file="arrow-button-down-2.svg"
            size="8"
            color="#696969"
          />
        </IconWrapper>
      );

    
  };

  getItems = () => {
    const { props, currentProps, bordered, renderPropFn } = this.props;
    return props.map((prop) => {
      const currentProp = currentProps[prop.name];
      const currentPropType = currentProps[`${prop.name}Type`];
      const currentValue =
        currentProp !== undefined ? currentProp : prop.defaultValue;
      const currentType =
        currentPropType !== undefined ? currentPropType : null;
      const content = renderPropFn(prop, currentValue, currentType);
      return bordered ? (
        <BorderedItem key={`${prop.element}-${prop.name}`}>
          {content}
        </BorderedItem>
      ) : (
        content
      );
    });
  };

  render() {
    const { 
      label, 
      locale, 
      toggleable, 
      bordered, 
      tooltip, 
      enabled, 
      tooltipLabel,
      groupType,
      separatorPosition
    } = this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    const conditionalPanelProps = {};
    const conditionCollapseProps = {};

    if (enabled || groupType === "separator") {
      conditionCollapseProps.defaultActiveKey = "default-enabled";
      conditionalPanelProps.key = "default-enabled";
    }

    const items = this.getItems();
    
    return (
      <CollapseWrapper
        selector={groupType}
        advancedOptions={false}
        onChange={this.handleToggableGroup}
        expandIcon={this.expandIcon}
        expandIconPosition="right"
        expandOnlyInIcon={toggleable || groupType === "separator"}
        separatorPosition={separatorPosition}
        {...conditionCollapseProps}
        className={`group-${groupType}`}
      >
        <Panel
          {...conditionalPanelProps}
          header={
            <>
              <EditorLabel tooltip={tooltipText} fontSize={11}>{label[locale]}</EditorLabel>
              {groupType === "separator" && tooltipLabel && (
                <IconQuestionWrapper>
                  <img src="https://icons.alboompro.com/v1/light/interface-essential/alerts/000000/question-circle.svg" alt="Icone dúvida" />
                  <Tooltip>{tooltipLabel[locale]}</Tooltip>
                </IconQuestionWrapper>
              )}
            </>
          }
        >
          {bordered ? <BorderedWrapper>{items}</BorderedWrapper> : items}
        </Panel>
      </CollapseWrapper>
    );
  }
}

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
});

export default connect(mapStateToProps, mapDispatchToProps)(Group);
